import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatGetApplicationStatusDetail} from '../repository/NatGetApplicationStatus'
import {
    SecondaryTableCell,
    SecondaryTableRowName,
    StyledTableCaption,
    TableRowName,
    TableRowNameTop,
} from '../../../../styledComponents/adminPage/Table'
import {
    APPLY_CATEGORY,
    APPLY_IRREGULAR_PATTERN,
    MESSAGE_TYPE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_ADMINISTRATOR,
} from '../../../../CodeMaster'
import {getApplicant} from '../common/helper/NatApplicationHelper'
import {BackLink, PrintLink} from '../../../../styledComponents/adminPage/Links'
import {Box, Table, TableBody, TableRow} from '@mui/material'
import moment from 'moment'
import {
    ApplyButtonTextWithIcon,
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    DelegateApprovalButton,
    SpApplicationDetailInfoContent,
    SpApplicationDetailInfoContentName,
    SpApplicationDetailInfoContentValue,
    SpApplicationInfoArea,
    SpApplicationInfoFooter,
    SpApplyCategory,
    SpApplyStatusCell,
    SpBackLinkArea,
    SpDelegateApprovalButton,
    SpPageFooterArea,
    StyledTableCell,
} from '../common/admin/NatAdminApplicationCommon'
import NatAdminApplicationRejectionDialog from '../common/admin/NatAdminApplicationRejectionDialog'
import {Messages} from '../../../../Messages'
import {HeadingAreaMessageParams} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatAdminApplicationReceptionDialog from '../common/admin/NatAdminApplicationReceptionDialog'
import {
    ApplicationStatusAdditionalInfo,
    NatApplicationStatusComponent,
} from '../common/admin/NatApplicationStatusComponent'
import {HKConstants} from '../../../../HKConstants'
import AuthorityChecker from '../../../../components/AuthorityChecker'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import NatAdminApplicationApprovalDelegateDialog from '../common/admin/NatAdminApplicationApprovalDelegateDialog'
import NatAdminApplicationApprovalDirectorDelegateComponent
    from '../common/admin/NatAdminApplicationApprovalDirectorDelegateComponent'
import {getRandomKey} from '../../../common/util/Natutil'
import {
    NatPutRejectionBrowseApplyRequest,
    NatPutRejectionBrowseApplyResponse,
} from '../repository/NatPutRejectionBrowseApply'
import {
    NatPutApprovalsBrowseApplyRequest,
    NatPutApprovalsBrowseApplyResponse,
} from '../repository/NatPutApprovalsBrowseApply'
import {getFormattedAddress} from '../contactAddressOnEmergencies/helper/NatContactAddressOnEmergencyHelper'
import {
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    RightRowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import {NatBrowseApplicationDocument} from '../common/admin/print/NatBrowseApplicationDocument'
import ReactToPrint from 'react-to-print'
import {NatBrowseApplyDetail} from '../repository/NatGetBrowseApply'
import {convertToMoment} from '../../../../components/reservations/helpers/helpers'
import NatAdminApplicationApprovalDialog from '../common/admin/NatAdminApplicationApprovalDialog'
import NatAdminBrowseWitnessForm from './admin/NatAdminBrowseWitnessForm'
import {NatAdminSpApplicationTabComponent} from '../common/admin/NatAdminSpApplicationTabComponent'
import {formatDateTimeWithoutSeconds} from '../../../../formatters/formatDate'
import {Check, Close} from '@mui/icons-material'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {PrintContentArea} from '../common/admin/print/NatAdminApplicatioPrintCommonStyle'
import {NatAdminApplicationCommentToAssocDirector} from '../common/admin/NatAdminApplicationCommentToAssocDirector'
import {Location} from 'react-router-dom'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    condominiumCd: string
    applyId: string
    applicationRepo: NatApplicationRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    browseApplyDetail: NatBrowseApplyDetail
    applicationStatusDetail: NatGetApplicationStatusDetail
    rejectionComment: string
    receptionComment: string
    approvalComment: string
    approvalBrowseWitnessInfo: BrowseWitnessInfo
    approvalButtonDisabled: boolean
    isLoadCompleted: boolean
    dialogStatus: Nullable<DialogContentType>
    actingChecked: boolean
    residentApplyProcess: RESIDENT_APPLY_PROCESS
}

export interface BrowseWitnessInfo {
    browseDate: string
    browseStartTime: string
    browseEndTime: string
    witness1RidgeNameRoomNumber: string
    witness1Name: string
    witness2RidgeNameRoomNumber: string
    witness2Name: string
    otherWitness: string
    isErrorOfPeriod: boolean
}

type DialogContentType = 'reception' | 'rejection' | 'delegate' | 'delegateApproval' | 'delegateRejection' | 'approval'

class NatAdminBrowsePage extends Component<Props & AdminPagePropsSet, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    ownUrl: string
    applicationRef: RefObject<HTMLDivElement>
    roleId: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        this.state = {
            browseApplyDetail: {
                applyId: '',
                applyStatus: '',
                condominiumName: '',
                ridgeName: '',
                roomNumber: '',
                applicantFamilyName: '',
                applicantFirstName: '',
                applyDate: '',
                browseReasonDetail: '',
                videoRecordingPlace: '',
                videoRecordingDate: '',
                videoRecordingStartTime: '',
                videoRecordingEndTime: '',
                browsePreferredDate: '',
                browsePreferredStartTime: '',
                browsePreferredEndTime: '',
                browseDate: null,
                browseStartTime: null,
                browseEndTime: null,
                witness1RidgeNameRoomNumber: null,
                witness1Name: null,
                witness2RidgeNameRoomNumber: null,
                witness2Name: null,
                otherWitness: null,
                accompany: null,
                note: null,
                version: 0,
            },
            applicationStatusDetail: {
                applyStatusInfo: [],
            },
            rejectionComment: '',
            receptionComment: '',
            approvalComment: '',
            approvalBrowseWitnessInfo: {
                browseDate: '',
                browseStartTime: '',
                browseEndTime: '',
                witness1RidgeNameRoomNumber: '',
                witness1Name: '',
                witness2RidgeNameRoomNumber: '',
                witness2Name: '',
                otherWitness: '',
                isErrorOfPeriod: false,
            },
            approvalButtonDisabled: true,
            actingChecked: true,
            dialogStatus: null,
            isLoadCompleted: false,
            residentApplyProcess: RESIDENT_APPLY_PROCESS.RECEPTION,
        }

        this.ownUrl = this.props.location.pathname
        this.applicationRef = React.createRef()

        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.handleReceptionClick = this.handleReceptionClick.bind(this)
        this.handleReceptionOkClick = this.handleReceptionOkClick.bind(this)
        this.handleRejectionClick = this.handleRejectionClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.handleApprovalClick = this.handleApprovalClick.bind(this)
        this.handleApprovalOkClick = this.handleApprovalOkClick.bind(this)
        this.handleDelegateClick = this.handleDelegateClick.bind(this)
        this.handleDelegateApprovalClick = this.handleDelegateApprovalClick.bind(this)
        this.handleDelegateApprovalOkClick = this.handleDelegateApprovalOkClick.bind(this)
        this.handleDelegateRejectionClick = this.handleDelegateRejectionClick.bind(this)
        this.handleDelegateRejectionOkClick = this.handleDelegateRejectionOkClick.bind(this)
        this.handleRejectionCommentChange = this.handleRejectionCommentChange.bind(this)
        this.handleReceptionCommentChange = this.handleReceptionCommentChange.bind(this)
        this.handleApprovalCommentChange = this.handleApprovalCommentChange.bind(this)
        this.handleBrowseWitnessInfoChange = this.handleBrowseWitnessInfoChange.bind(this)
        this.onChangeActingChecked = this.onChangeActingChecked.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyInfo()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getApplyInfo(): Promise<void> {
        const [browseApplyResponse, applicationStatusResponse] = await Promise.all([
            this.getBrowseApply(),
            this.getApplicationStatus(),
        ])

        if (browseApplyResponse && applicationStatusResponse) {
            const residentApplyProcess: RESIDENT_APPLY_PROCESS =
                browseApplyResponse.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value
                    ? RESIDENT_APPLY_PROCESS.RECEPTION : RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL
            this.setState({
                browseApplyDetail: browseApplyResponse,
                applicationStatusDetail: applicationStatusResponse,
                residentApplyProcess: residentApplyProcess,
            })
        }
    }

    async getBrowseApply(): Promise<Nullable<NatBrowseApplyDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getBrowseApply.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async getApplicationStatus(): Promise<Nullable<NatGetApplicationStatusDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getApplicationStatus.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    getApplicationStatusAdditionalInfo(): Nullable<ApplicationStatusAdditionalInfo> {
        const {
            browseDate, browseStartTime, browseEndTime,
            witness1RidgeNameRoomNumber, witness1Name,
            witness2RidgeNameRoomNumber, witness2Name,
            otherWitness,
        } = this.state.browseApplyDetail

        if (!(browseDate && browseStartTime && browseEndTime)) {
            return null
        }

        const formatBrowseDate = convertToMoment(browseDate, null).format('YYYY年M月D日')
        const formatBrowseStartTime = convertToMoment(browseDate, browseStartTime).format('H:mm')
        const formatBrowseEndTime = convertToMoment(browseDate, browseEndTime).format('H:mm')
        let comment: string = `閲覧日時　${formatBrowseDate} ${formatBrowseStartTime}～${formatBrowseEndTime}`

        let witnesses: string[] = []
        witnesses.push([witness1RidgeNameRoomNumber, witness1Name].filter(Boolean).join(' '))
        witnesses.push([witness2RidgeNameRoomNumber, witness2Name].filter(Boolean).join(' '))
        witnesses.push([otherWitness].filter(Boolean).join(' '))
        witnesses = witnesses.filter(Boolean)

        if (witnesses.length > 0) {
            comment = `${comment}\n立会いする理事等　${witnesses.join('、')}`
        }

        return {
            targetProcess: RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL,
            commentTitle: '閲覧日時・立会い理事',
            comment: comment,
        }
    }

    handleDialogCancelClick(): void {
        this.setState({
            rejectionComment: '',
            receptionComment: '',
            approvalComment: '',
            approvalBrowseWitnessInfo: {
                browseDate: '',
                browseStartTime: '',
                browseEndTime: '',
                witness1RidgeNameRoomNumber: '',
                witness1Name: '',
                witness2RidgeNameRoomNumber: '',
                witness2Name: '',
                otherWitness: '',
                isErrorOfPeriod: false,
            },
            approvalButtonDisabled: true,
            dialogStatus: null,
            actingChecked: true,
        })
    }

    handleReceptionClick(): void {
        this.setState({dialogStatus: 'reception'})
    }

    handleRejectionClick(): void {
        this.setState({dialogStatus: 'rejection'})
    }

    handleApprovalClick(): void {
        this.setState({dialogStatus: 'approval'})
    }

    handleDelegateClick(): void {
        this.setState({dialogStatus: 'delegate'})
    }

    handleDelegateApprovalClick(): void {
        this.setState({dialogStatus: 'delegateApproval'})
    }

    handleDelegateRejectionClick(): void {
        this.setState({dialogStatus: 'delegateRejection'})
    }

    onChangeActingChecked(checked: boolean): void {
        this.setState({actingChecked: !checked})
    }

    handleRejectionCommentChange(value: string): void {
        this.setState({rejectionComment: value})
    }

    handleReceptionCommentChange(value: string): void {
        this.setState({receptionComment: value})
    }

    handleApprovalCommentChange(value: string): void {
        this.setState({approvalComment: value})
    }

    handleBrowseWitnessInfoChange(value: BrowseWitnessInfo): void {
        const {
            browseDate,
            browseStartTime,
            browseEndTime,
            isErrorOfPeriod,
        } = value

        let approvalButtonDisabled = false

        if (!browseDate || !browseStartTime || !browseEndTime || isErrorOfPeriod) {
            approvalButtonDisabled = true
        }
        this.setState({
            approvalBrowseWitnessInfo: value,
            approvalButtonDisabled: approvalButtonDisabled,
        })
    }

    async handleRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {residentApplyProcess, rejectionComment, browseApplyDetail} = this.state

        const assocFlag = this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionBrowseApplyRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: null,
                comment: rejectionComment,
                version: browseApplyDetail.version,
            }

            const response: Nullable<NatPutRejectionBrowseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionBrowseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                if (!assocFlag) {
                    this.props.navigate(`${this.ownUrl}`, {
                        replace: true,
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0004.toString('申請'),
                            },
                            refreshToken: getRandomKey(),
                        },
                    })
                } else {
                    this.props.navigate('/admin/applications', {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0006.toString(
                                    '申請',
                                    this.state.browseApplyDetail.applyId,
                                    APPLY_CATEGORY.INSPECTION_APPLY.label),
                            },
                        },
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleReceptionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {residentApplyProcess, receptionComment, browseApplyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsBrowseApplyRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: null,
                browseDate: null,
                browseStartTime: null,
                browseEndTime: null,
                witness1RidgeNameRoomNumber: null,
                witness1Name: null,
                witness2RidgeNameRoomNumber: null,
                witness2Name: null,
                otherWitness: null,
                comment: receptionComment || null,
                version: browseApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalsBrowseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalBrowseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0003.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {browseApplyDetail, residentApplyProcess, approvalComment} = this.state
        const {
            browseDate,
            browseStartTime,
            browseEndTime,
            witness1RidgeNameRoomNumber,
            witness1Name,
            witness2RidgeNameRoomNumber,
            witness2Name,
            otherWitness,
        } = this.state.approvalBrowseWitnessInfo

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsBrowseApplyRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: null,
                browseDate: browseDate || null,
                browseStartTime: browseStartTime || null,
                browseEndTime: browseEndTime || null,
                witness1RidgeNameRoomNumber: witness1RidgeNameRoomNumber || null,
                witness1Name: witness1Name || null,
                witness2RidgeNameRoomNumber: witness2RidgeNameRoomNumber || null,
                witness2Name: witness2Name || null,
                otherWitness: otherWitness || null,
                comment: approvalComment || null,
                version: browseApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalsBrowseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalBrowseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate('/admin/applications', {
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0005.toString(
                                '申請',
                                browseApplyDetail.applyId,
                                APPLY_CATEGORY.INSPECTION_APPLY.label),
                        },
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {browseApplyDetail, residentApplyProcess, approvalComment} = this.state
        const {
            browseDate,
            browseStartTime,
            browseEndTime,
            witness1RidgeNameRoomNumber,
            witness1Name,
            witness2RidgeNameRoomNumber,
            witness2Name,
            otherWitness,
        } = this.state.approvalBrowseWitnessInfo

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsBrowseApplyRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                browseDate: browseDate || null,
                browseStartTime: browseStartTime || null,
                browseEndTime: browseEndTime || null,
                witness1RidgeNameRoomNumber: witness1RidgeNameRoomNumber || null,
                witness1Name: witness1Name || null,
                witness2RidgeNameRoomNumber: witness2RidgeNameRoomNumber || null,
                witness2Name: witness2Name || null,
                otherWitness: otherWitness || null,
                comment: approvalComment || null,
                version: browseApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalsBrowseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalBrowseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0007.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, browseApplyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionBrowseApplyRequest = {
                operation: RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: rejectionComment,
                version: browseApplyDetail.version,
            }

            const response: Nullable<NatPutRejectionBrowseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionBrowseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0004.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    renderDetailsTable(): ReactNode {
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            browseReasonDetail,
            videoRecordingPlace,
            videoRecordingDate,
            videoRecordingStartTime,
            videoRecordingEndTime,
            browsePreferredDate,
            browsePreferredStartTime,
            browsePreferredEndTime,
            accompany,
            note,
        } = this.state.browseApplyDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <>
                <Table>
                    <StyledTableCaption>申請内容</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請ID</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {applyId}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {APPLY_CATEGORY.INSPECTION_APPLY.label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {condominiumName + '　' + applicant}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請日</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {moment(applyDate).format('YYYY年M月D日 H時m分')}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>閲覧理由</TableRowName>
                            <StyledTableCell colSpan={4}>
                                <Box whiteSpace={'pre-wrap'}>{browseReasonDetail}</Box>
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowNameTop rowSpan={4}>閲覧したい録画映像</TableRowNameTop>
                            <SecondaryTableRowName>
                                場所
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {videoRecordingPlace}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                日付
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {moment(videoRecordingDate).format('YYYY年M月D日')}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                開始時間
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {convertToMoment(videoRecordingDate, videoRecordingStartTime).format('H時mm分')}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName end>
                                終了時間
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3} end>
                                {convertToMoment(videoRecordingDate, videoRecordingEndTime).format('H時mm分')}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowNameTop rowSpan={3}>閲覧の希望日時</TableRowNameTop>
                            <SecondaryTableRowName>
                                日付
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {moment(browsePreferredDate).format('YYYY年M月D日')}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName>
                                開始時間
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {convertToMoment(browsePreferredDate, browsePreferredStartTime).format('H時mm分')}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName end>
                                終了時間
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3} end>
                                {convertToMoment(browsePreferredDate, browsePreferredEndTime).format('H時mm分')}
                            </SecondaryTableCell>
                        </TableRow>
                        {accompany?.map(recode => {
                            const {
                                seq,
                                relationship,
                                accompanyName,
                                zipCode,
                                prefecture,
                                address2,
                                address3,
                                buildingRoomNumber,
                            } = recode

                            const address = getFormattedAddress(
                                zipCode ?? '',
                                prefecture ?? '',
                                address2 ?? '',
                                address3 ?? '',
                                buildingRoomNumber ?? '',
                            )

                            return (
                                <React.Fragment key={seq}>
                                    <TableRow>
                                        <TableRowNameTop rowSpan={3}>同行者{seq}</TableRowNameTop>
                                        <SecondaryTableRowName>
                                            氏名
                                        </SecondaryTableRowName>
                                        <SecondaryTableCell colSpan={3}>
                                            {accompanyName}
                                        </SecondaryTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <SecondaryTableRowName>
                                            続柄
                                        </SecondaryTableRowName>
                                        <SecondaryTableCell colSpan={3}>
                                            {relationship}
                                        </SecondaryTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <SecondaryTableRowName end>
                                            住所
                                        </SecondaryTableRowName>
                                        <SecondaryTableCell colSpan={3} end>
                                            {address}
                                        </SecondaryTableCell>
                                    </TableRow>
                                </React.Fragment>
                            )
                        })}
                        <TableRow>
                            <TableRowName>備考</TableRowName>
                            <StyledTableCell colSpan={4}>
                                <Box whiteSpace={'pre-wrap'}>{note}</Box>
                            </StyledTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): ReactNode {
        const {browseApplyDetail, applicationStatusDetail} = this.state

        return (
            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                <Box mt={'20px'}>
                    <RightRowFlexContainer>
                        <ReactToPrint
                            trigger={() => (
                                <PrintLink>
                                    <Box ml={'10px'}>
                                        印刷する
                                    </Box>
                                </PrintLink>
                            )}
                            content={() => this.applicationRef.current}
                        />
                        <PrintContentArea>
                            <div ref={this.applicationRef}>
                                <NatBrowseApplicationDocument
                                    browseApplicationDocumentParam={browseApplyDetail}
                                    applyStatusInfoList={applicationStatusDetail.applyStatusInfo}
                                />
                            </div>
                        </PrintContentArea>
                    </RightRowFlexContainer>
                </Box>
            </AuthorityChecker>
        )
    }

    renderPageFooterArea(): ReactNode {
        const {browseApplyDetail} = this.state

        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧に戻る
                    </BackLink>
                </PageFotterAreaLeft>
                {(browseApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <DelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </DelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><Box ml={'8px'}/>承認する
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
                {(browseApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><Box ml={'8px'}/>受け付ける
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
            </>
        )
    }

    renderPc(): ReactElement {
        return (
            <>
                <Box mb={'20px'}>
                    {this.renderPageHeaderArea()}
                </Box>
                <PageMainArea>
                    {this.renderDetailsTable()}
                    <NatApplicationStatusComponent
                        currentApplyStatus={this.state.browseApplyDetail.applyStatus}
                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                        additionalInfo={this.getApplicationStatusAdditionalInfo()}
                    />
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

    renderSpApplicationInfo(): ReactNode {
        const {browseApplyDetail, applicationStatusDetail} = this.state
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            applyStatus,
        } = browseApplyDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <SpApplicationInfoArea>
                <LeftColumnFlexContainer>
                    <div>{applyId}</div>
                    <FullWidthRowFlexContainer>
                        <SpApplyCategory>
                            {APPLY_CATEGORY.INSPECTION_APPLY.label}
                        </SpApplyCategory>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                            <ReactToPrint
                                trigger={() => (
                                    <PrintLink>
                                        <Box ml={'10px'}>
                                            印刷する
                                        </Box>
                                    </PrintLink>
                                )}
                                content={() => this.applicationRef.current}/>
                            <PrintContentArea>
                                <div ref={this.applicationRef}>
                                    <NatBrowseApplicationDocument
                                        browseApplicationDocumentParam={browseApplyDetail}
                                        applyStatusInfoList={applicationStatusDetail.applyStatusInfo}
                                    />
                                </div>
                            </PrintContentArea>
                        </AuthorityChecker>
                    </FullWidthRowFlexContainer>
                    <Box pt={'12px'}>
                        <div>{condominiumName}</div>
                        <div>{applicant}</div>
                    </Box>
                    <Box height={'12px'}/>
                    <SpApplicationInfoFooter>
                        <div>
                            {formatDateTimeWithoutSeconds(applyDate)} に提出
                        </div>
                        <SpApplyStatusCell status={applyStatus}>
                            {RESIDENT_APPLY_STATUS.codeToEnumConstants(applyStatus).label}
                        </SpApplyStatusCell>
                    </SpApplicationInfoFooter>
                </LeftColumnFlexContainer>
            </SpApplicationInfoArea>
        )
    }

    renderSpPageFooterArea(): ReactNode {
        const {applyStatus} = this.state.browseApplyDetail
        return (
            <>
                {(applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <SpDelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </SpDelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><ApplyButtonTextWithIcon>承認する</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
                {(applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><ApplyButtonTextWithIcon>受け付ける</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
            </>
        )
    }

    renderSpCommentToAssocDirector(): ReactNode {
        const {browseApplyDetail, applicationStatusDetail} = this.state
        if (browseApplyDetail.applyStatus !== RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) {
            return null
        }

        const commentToAssocDirectorInfo = applicationStatusDetail.applyStatusInfo
            .find(status => status.applyProcess === RESIDENT_APPLY_PROCESS.RECEPTION.value)
            ?.actual

        if (!(commentToAssocDirectorInfo?.comment)) {
            return null
        }

        return <Box pb={'16px'}>
            <NatAdminApplicationCommentToAssocDirector
                comment={commentToAssocDirectorInfo.comment}
                roleId={commentToAssocDirectorInfo.roleId}
                familyName={commentToAssocDirectorInfo.familyName}
                firstName={commentToAssocDirectorInfo.firstName}
                registerDatetime={commentToAssocDirectorInfo.registerDatetime}
            />
        </Box>
    }

    renderSpApplicationDetailInfo(): ReactNode {
        const {
            browseReasonDetail,
            videoRecordingPlace,
            videoRecordingDate,
            videoRecordingStartTime,
            videoRecordingEndTime,
            browsePreferredDate,
            browsePreferredStartTime,
            browsePreferredEndTime,
            accompany,
            note,
        } = this.state.browseApplyDetail

        return (
            <>

                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>閲覧理由</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        <Box whiteSpace={'pre-wrap'}>
                            {browseReasonDetail}
                        </Box>
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>閲覧したい録画映像</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        場所：{videoRecordingPlace}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        日付：{moment(videoRecordingDate).format('YYYY年M月D日')}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        開始時間：{convertToMoment(videoRecordingDate, videoRecordingStartTime).format('H時mm分')}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        終了時間：{convertToMoment(videoRecordingDate, videoRecordingEndTime).format('H時mm分')}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>閲覧の希望日時</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        日付：{moment(browsePreferredDate).format('YYYY年M月D日')}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        開始時間：{convertToMoment(browsePreferredDate, browsePreferredStartTime).format('H時mm分')}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        終了時間：{convertToMoment(browsePreferredDate, browsePreferredEndTime).format('H時mm分')}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                {accompany?.map(recode => {
                    const {
                        seq,
                        relationship,
                        accompanyName,
                        zipCode,
                        prefecture,
                        address2,
                        address3,
                        buildingRoomNumber,
                    } = recode

                    const address = getFormattedAddress(
                        zipCode ?? '',
                        prefecture ?? '',
                        address2 ?? '',
                        address3 ?? '',
                        buildingRoomNumber ?? '',
                    )

                    return (
                        <SpApplicationDetailInfoContent>
                            <SpApplicationDetailInfoContentName>同行者{seq}</SpApplicationDetailInfoContentName>
                            <SpApplicationDetailInfoContentValue>
                                氏名：{accompanyName}
                            </SpApplicationDetailInfoContentValue>
                            <SpApplicationDetailInfoContentValue>
                                続柄：{relationship}
                            </SpApplicationDetailInfoContentValue>
                            <SpApplicationDetailInfoContentValue>
                                住所：{address}
                            </SpApplicationDetailInfoContentValue>
                        </SpApplicationDetailInfoContent>
                    )
                })}
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>備考</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        <Box whiteSpace={'pre-wrap'}>
                            {note}
                        </Box>
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                {this.renderSpPageFooterArea()}
            </>
        )
    }

    renderSpApplicationStatusInfo(): ReactNode {
        return (
            <NatApplicationStatusComponent
                currentApplyStatus={this.state.browseApplyDetail.applyStatus}
                applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                additionalInfo={this.getApplicationStatusAdditionalInfo()}
            />
        )
    }

    renderSp(): ReactElement {
        return (
            <>
                <SpBackLinkArea>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧
                    </BackLink>
                </SpBackLinkArea>
                {this.renderSpApplicationInfo()}
                <Box height={'16px'}/>
                {this.renderSpCommentToAssocDirector()}
                <NatAdminSpApplicationTabComponent
                    detailInfo={this.renderSpApplicationDetailInfo()}
                    statusInfo={this.renderSpApplicationStatusInfo()}
                />
                <Box height={`32px`}/>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return (
            <>
                {spMode ? this.renderSp() : this.renderPc()}
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'rejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationReceptionDialog
                    open={this.state.dialogStatus === 'reception'}
                    onCancel={this.handleDialogCancelClick}
                    onReception={this.handleReceptionOkClick}
                    eventEmitter={this.props.eventEmitter}
                    onChange={this.handleReceptionCommentChange}
                    commentFormRequired={true}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'approval'}
                    optionComponent={
                        <NatAdminBrowseWitnessForm
                            isInitial={this.state.dialogStatus === 'delegateApproval'}
                            onChange={this.handleBrowseWitnessInfoChange}
                            eventEmitter={this.props.eventEmitter}/>
                    }
                    approvalButtonDisabled={this.state.approvalButtonDisabled}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onChange={this.handleApprovalCommentChange}
                    onApproval={this.handleApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDelegateDialog
                    open={this.state.dialogStatus === 'delegate'}
                    delegateComponent={<NatAdminApplicationApprovalDirectorDelegateComponent
                        onChange={this.onChangeActingChecked}/>}
                    rejectionButtonDisabled={this.state.actingChecked}
                    approvalButtonDisabled={this.state.actingChecked}
                    onApproval={this.handleDelegateApprovalClick}
                    onRejection={this.handleDelegateRejectionClick}
                    onCancel={this.handleDialogCancelClick}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'delegateApproval'}
                    optionComponent={
                        <NatAdminBrowseWitnessForm
                            isInitial={this.state.dialogStatus === 'delegateApproval'}
                            onChange={this.handleBrowseWitnessInfoChange}
                            eventEmitter={this.props.eventEmitter}/>
                    }
                    approvalButtonDisabled={this.state.approvalButtonDisabled}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onChange={this.handleApprovalCommentChange}
                    onApproval={this.handleDelegateApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'delegateRejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleDelegateRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }
}

NatAdminBrowsePage.contextType = AppAdminContext
export default createAdminPage(NatAdminBrowsePage)
